import React from 'react';
import axios from "axios";
import {AppBar, TextField, Typography, Button} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {
    ExitToApp,
    PersonOutline,
    Menu,
    NavigateNext,
    NavigateBefore,
    WorkOutline,
    Add,
    Layers,
    Opacity,
    CloudUpload,
    Settings
} from '@material-ui/icons';
import {userService} from "../../../services/UserService";
import {connect} from "react-redux";
import {parseNameParcela} from "../../../tools/ParseNameParcela";
import moment from "moment";
import 'moment/locale/es';
import {IStore} from "../../../store/reducers";
import actionTypes from "../../../store/actionTypes";
import {IPointCoords, INotificacion, IParcela, ISections} from "../../../types";
import {LatLngTuple} from "leaflet";
import {getCenterZoom} from "../../../tools/getCenterZoom";
import ElTiempo from "../../../CropSense/components/ElTiempo"
import {callback} from "chart.js/helpers";
moment.locale('es');

const config = require('../../../config.json');
const texts = require('../../../texts/navbar.json')


interface FProps {
    selectSection(section: ISections): void
    setPropietario(propietario: string): void
    setNombre(nombre: string): void
    setPolygon(polygon: LatLngTuple[]): void
    setSectores(sectores: Record<string, LatLngTuple[]>): void
    setZoom(zoom: number): void
    setCenter(center: LatLngTuple): void
    handleMenu(): void
    setPrincipalUsuario(usuario: string): void
    setMenu(menu: boolean): void
    setElTiempoLatLon(elTiempoLatLon: IPointCoords): void
    setParcela(parcela: string): void
    setVisualizadorParcela(parcela: IParcela): void
    setVisualizadorSectores(sectores: Record<string, LatLngTuple[]>): void
    setParcelas(parcelas: IParcela[]): void
    setRiego(riego: Record<string, Record<string, number>>): void
    setPronostico(pronostico: Record<string, Record<string, number>>): void
    notify(notification: INotificacion): void
    setRiegoParcela(parcela: IParcela): void
    setRiegoSectores(sectores: Record<string, LatLngTuple[]>): void
    setSubirDatosParcela(parcela: IParcela): void
    Cargando(cargando: boolean): void
    section: ISections
    parcelas: IParcela[]
    zoom: number
    center: LatLngTuple
    level: number
    usuarios: string[]
    usuario: string
    menu: boolean
    LatLon: IPointCoords
    parcela: string
    idioma: string
}

interface FState {
    hover: string
    clickedPerson: boolean
    clickedParcelas: boolean
    tags: Record<string, string>
    onSettings: boolean
    text: Record<string, string>
}



class NavBar extends React.Component<FProps, FState>{

    state: FState = {
        hover: '',
        clickedPerson: false,
        clickedParcelas: false,
        tags: {} as Record<string, string>,
        onSettings: false,
        text: texts[this.props.idioma]
    };

    shouldComponentUpdate(nextProps: Readonly<FProps>, nextState: Readonly<FState>, nextContext: any): boolean {
        if (this.props.idioma !== nextProps.idioma) {
            this.setState({
                text: texts[nextProps.idioma]
            })
        }
        return true
    }

    delay = (ms: number) => new Promise(res => setTimeout(res, ms));

    getPronostico = async (id: string) => {
        let counter = 0
        while (counter < 5) {
            let date = new Date()
            date.setDate(date.getDate() - counter)
            let fecha = date.toISOString().split('T')[0].split('-').join('_')

            if (userService.getUser() === 'demo') {
                const data = {
                    "2021-08-23": {
                        "lluvia": 0,
                        "v_viento": 23,
                        "v_raf_viento": 49,
                        "t_max": 40,
                        "t_min": 24,
                        "cielo_id": 2,
                        "nubosidad": 12
                    },
                    "2021-08-24": {
                        "lluvia": 7,
                        "v_viento": 23,
                        "v_raf_viento": 48,
                        "t_max": 33,
                        "t_min": 22,
                        "cielo_id": 12,
                        "nubosidad": 61
                    },
                    "2021-08-25": {
                        "lluvia": 0,
                        "v_viento": 19,
                        "v_raf_viento": 36,
                        "t_max": 33,
                        "t_min": 18,
                        "cielo_id": 1,
                        "nubosidad": 7
                    },
                    "2021-08-26": {
                        "lluvia": 0,
                        "v_viento": 12,
                        "v_raf_viento": 28,
                        "t_max": 32,
                        "t_min": 17,
                        "cielo_id": 1,
                        "nubosidad": 0
                    },
                    "2021-08-27": {
                        "lluvia": 0,
                        "v_viento": 19,
                        "v_raf_viento": 39,
                        "t_max": 32,
                        "t_min": 18,
                        "cielo_id": 1,
                        "nubosidad": 5
                    }
                }
                this.props.setPronostico(data as Record<string, Record<string, number>>)
                counter = 100
            } else {
                axios.get(
                    config.url + `/static/visualizador/pronostico_tiempo/${id}/${fecha}.json`,
                    {
                        auth: {
                            username: `${userService.getUser()}`,
                            password: `${userService.getPass()}`
                        }
                    })
                    .then((res) => {
                        this.props.setPronostico(res.data)
                        counter = 100
                    })
                    .catch(async () => {
                        counter += 1
                    })
                await this.delay(1000)
            }
        }
    }

    resetCrearParcela = () => {
        this.props.setNombre('')
        this.props.setPropietario('')
        this.props.setPolygon([])
        this.props.setSectores({})
    }

    IdNombreUsuario = ():Record<string, string>[] => {
        const id2name: Record<string, string>[] = []
        for (const usuario of this.props.usuarios) {
            id2name.push({
                id: usuario,
                nombre: usuario
            })
        }
        return id2name
    }

    IdNombreParcela = ():Record<string, string>[] => {
        const id2name: Record<string, string>[] = []
        for (const parcela of this.props.parcelas) {
            if (parcela.eliminada === 1) continue
            if (!parcela.propietario.split(',').includes(this.props.usuario)) continue
            id2name.push({
                id: parcela.id,
                nombre: parcela.nombre
            })
        }
        return id2name
    }

    onTagsChange = async (id: string) => {
        for (const parcela of this.props.parcelas) {
            if (parcela.id === id ) {
                this.props.setParcela(id)
                const center = getCenterZoom(parcela.lat_lon).center
                this.props.setZoom(17)
                this.props.setCenter(center)
                this.props.setElTiempoLatLon({
                    lat: center[0],
                    lon: center[1]
                })
            }
        }
    }


    handleClickVisualizador = () => {
        axios.get(
            config.url+`/get/sectores?id=${this.props.parcela}`,
            {auth: {
                    username: `${userService.getUser()}`,
                    password: `${userService.getPass()}`
                }})
            .then((res: { data: Record<string, LatLngTuple[]> }) => {
                this.props.setVisualizadorSectores(res.data)

                for (const parcela of this.props.parcelas) {
                    if (parcela.id === this.props.parcela) this.props.setVisualizadorParcela(parcela)
                }

                this.props.selectSection('visualizador')

            })
            .catch(() => {
                return
            })

    }

    handleClickRiegoNeto = () => {

        axios.get(
            config.url+`/get/sectores?id=${this.props.parcela}`,
            {auth: {
                    username: `${userService.getUser()}`,
                    password: `${userService.getPass()}`
                }})
            .then((res: { data: Record<string, LatLngTuple[]> }) => {
                this.props.setRiegoSectores(res.data)

                for (const parcela of this.props.parcelas) {
                    if (parcela.id === this.props.parcela) {
                        this.props.setRiegoParcela(parcela)
                        break
                    }
                }

                this.setState({clickedPerson: false, clickedParcelas: false})
                this.props.selectSection('riego_neto')

            })
            .catch(() => {
                return
            })
    }

    cambiaUsuario = (user:string) => {
        let sin_parcela = true
        for (let parcela of this.props.parcelas) {
            if (parcela.propietario.split(',').includes(user)) {
                sin_parcela = false
                break
            }
        }
        if (sin_parcela) this.props.setParcela('')
        this.props.setPrincipalUsuario(user)
        this.props.selectSection('principal')
        this.setState({clickedPerson: false})
    }


    selectParcela = (parcela: string) => {
        this.props.selectSection('principal')
        if (parcela === this.props.parcela) return
        this.onTagsChange(parcela)

        const url: string = config.url+`/calcula/riego?parcela=${parcela}`
        this.props.Cargando(true)
        axios.get(
            url,
            {auth: {
                    username: `${userService.getUser()}`,
                    password: `${userService.getPass()}`
                }})
            .then((res) => {
                this.props.setRiego(res.data)
                this.props.Cargando(false)
            })
            .catch(() => {
                // this.props.notify({message: this.state.text["7"], variant: 'error'})
                this.props.Cargando(false)
            })

        this.getPronostico(parcela)
    }

    handleUploadData = () => {
        for (const parcela of this.props.parcelas) {
            if (parcela.id === this.props.parcela) this.props.setSubirDatosParcela(parcela)
        }
        this.props.selectSection('subir_datos')
    }

    render() {
        const options_usuarios = this.IdNombreUsuario()
        const options = this.IdNombreParcela()
        return (
            <AppBar style={{
                display: "flex",
                flexDirection: 'column',
                position: 'relative',
                width: this.props.menu? '18%': '5%',
                marginRight: this.props.menu? '-18%': '-5%',
                height: '100%',
                alignItems: "center",
                borderTopRightRadius: 40,
                borderBottomRightRadius: 40,
                backgroundColor: "white"
            }}>
                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css?family=Poppins"
                />
                {this.props.menu?
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            marginTop: 40,
                            width: '100%',
                            height: 60,
                            justifyContent: "center",
                            alignItems: "center"
                        }}
                    >
                        <Typography
                            style={{
                                textAlign: "center",
                                width: '100%',
                                fontWeight: "bold",
                                fontFamily: "Poppins",
                                fontSize: 34
                            }}
                        >
                            CropSense
                        </Typography>
                        <div
                            style={{
                                zIndex: 10,
                                width: 60,
                                height: 60,
                                marginRight: -40,
                                backgroundColor: "white",
                                borderRadius: 20
                            }}
                        >
                            <Button
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    borderRadius: 20
                                }}
                                onClick={() => {
                                    this.props.setMenu(false)
                                }}
                            >
                                <Menu
                                    style={{
                                        height: 35,
                                        width: 35
                                    }}
                                />
                            </Button>
                        </div>
                    </div>
                    :
                    <Button
                        style={{
                            marginTop: 40,
                            width: 60,
                            height: 60,
                            borderRadius: 20
                        }}
                        onClick={() => {
                            this.props.setMenu(true)
                        }}
                    >
                        <Menu
                            style={{
                                height: 35,
                                width: 35
                            }}
                        />
                    </Button>
                }


                {this.props.menu &&
                    <ElTiempo/>
                }


                {this.props.menu?
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            marginTop: 20,
                            width: '100%',
                            height: 80,
                            justifyContent: "space-between",
                            alignItems: "center",
                            backgroundColor: '#80ED99',
                            borderRadius: 10,
                            borderTopRightRadius: this.state.clickedPerson? 0 : 10,
                            borderBottomRightRadius: this.state.clickedPerson? 0 : 10,
                            cursor: "pointer"
                        }}
                    >
                        <PersonOutline
                            style={{
                                height: 35,
                                width: '20%'
                            }}
                        />
                        <Typography
                            style={{
                                width: '80%',
                                fontWeight: "bold",
                                fontSize: 24,
                                fontFamily: "Poppins",
                            }}
                        >
                            {this.props.usuario}
                        </Typography>

                    </div>
                    :
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            marginTop: 20,
                            width: '100%',
                            height: 80,
                            alignItems: "center",
                            justifyContent: "center"
                        }}
                    >
                        <Button
                            style={{
                                width: 60,
                                height: 60,
                                borderRadius: 20,
                                borderWidth: this.state.clickedPerson? 1 : 0,
                                borderStyle: "solid"
                            }}
                            disabled={true}
                        >
                            <PersonOutline
                                style={{
                                    height: 35,
                                    width: 35
                                }}
                            />
                        </Button>
                    </div>
                }


                {this.props.menu?
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            marginTop: 20,
                            width: '100%',
                            height: 80,
                            justifyContent: "space-between",
                            alignItems: "center",
                            cursor: "pointer",
                            backgroundColor: this.state.clickedParcelas? '#f1f1f1' : undefined,
                            borderBottomLeftRadius: 20,
                            borderTopLeftRadius: 20
                        }}
                        onClick={() => this.setState({
                            clickedParcelas: !this.state.clickedParcelas,
                            clickedPerson: false
                        })}
                    >
                        <WorkOutline
                            style={{
                                height: 35,
                                width: '20%'
                            }}
                        />
                        <Typography
                            style={{
                                width: '60%',
                                fontSize: 18,
                                fontFamily: "Poppins",
                            }}
                        >
                            {this.state.text["2"]}
                        </Typography>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                width: '15%',
                                height: 80,
                                borderRadius: 10
                            }}
                        >
                            {this.state.clickedParcelas?
                                <NavigateBefore
                                    style={{
                                        height: 35,
                                        width: 35
                                    }}
                                />
                                :
                                <NavigateNext
                                    style={{
                                        height: 35,
                                        width: 35
                                    }}
                                />
                            }
                        </div>
                        {this.state.clickedParcelas &&
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    width: 200,
                                    height: "auto",
                                    minHeight: 80,
                                    alignSelf: "flex-start",
                                    backgroundColor: "#f1f1f1",
                                    marginRight: -200,
                                    borderTopRightRadius: 20,
                                    borderBottomRightRadius: 20,
                                    alignItems: "flex-start"
                                }}
                            >
                                {options.map(element =>
                                    <div
                                        key={element.id}
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            width: '100%'
                                        }}
                                    >
                                        <Button
                                            style={{
                                                width: '100%',
                                                backgroundColor: this.props.parcela === element.id? '#80ED99' : undefined,
                                                borderRadius: 20
                                            }}
                                            onClick={() => {
                                                if (!this.state.onSettings) {
                                                    this.selectParcela(element.id)
                                                    this.setState({clickedParcelas: false})
                                                }
                                            }}
                                        >
                                            <Typography
                                                style={{
                                                    width: '100%',
                                                    textTransform: "none",
                                                    textAlign: "start",
                                                    margin: 5,
                                                    fontFamily: "Poppins",
                                                }}
                                            >
                                                {parseNameParcela(element.nombre)}
                                            </Typography>

                                        </Button>
                                    </div>
                                )}

                            </div>
                        }
                    </div>
                    :
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            marginTop: 20,
                            width: '100%',
                            height: 80,
                            alignItems: "center",
                            justifyContent: "center"
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                width: '100%',
                                height: 60,
                                justifyContent: "center"
                            }}
                        >
                            <Button
                                style={{
                                    width: 60,
                                    height: 60,
                                    borderRadius: 20,
                                    borderWidth: this.state.clickedParcelas? 1 : 0,
                                    borderStyle: "solid"
                                }}
                                onClick={() => this.setState({
                                    clickedParcelas: !this.state.clickedParcelas,
                                    clickedPerson: false
                                })}
                            >
                                <WorkOutline
                                    style={{
                                        height: 35,
                                        width: 35
                                    }}
                                />
                            </Button>
                        </div>


                        {this.state.clickedParcelas &&
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    width: 200,
                                    height: "auto",
                                    minHeight: 80,
                                    alignSelf: "flex-start",
                                    backgroundColor: "white",
                                    marginRight: -200,
                                    alignItems: "flex-start",
                                    borderTopRightRadius: 20,
                                    borderBottomRightRadius: 20
                                }}
                            >
                                {options.map(element =>
                                    <div
                                        key={element.id}
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            width: '100%'
                                        }}
                                    >
                                        <Button
                                            style={{
                                                width: '100%',
                                                backgroundColor: this.props.parcela === element.id? '#80ED99' : undefined,
                                                borderRadius: 20
                                            }}
                                            onClick={() => {
                                                if (!this.state.onSettings) {
                                                    this.selectParcela(element.id)
                                                    this.setState({clickedParcelas: false})
                                                }
                                            }}
                                        >
                                            <Typography
                                                style={{
                                                    width: '100%',
                                                    textTransform: "none",
                                                    textAlign: "start",
                                                    margin: 5,
                                                    fontFamily: "Poppins",
                                                }}
                                            >
                                                {parseNameParcela(element.nombre)}
                                            </Typography>
                                        </Button>
                                    </div>
                                )}

                            </div>
                        }

                    </div>
                }





                {this.props.menu?
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            width: '100%',
                            height: 80,
                            justifyContent: "space-between",
                            alignItems: "center",
                            borderRadius: 10,
                            backgroundColor: this.props.section === "riego_neto"?
                                '#ddd'
                                :
                                this.state.hover === 'riego_neto'? '#eee' : '#fff',
                            cursor: this.props.parcela.length === 0? "auto" : "pointer"
                        }}
                        onMouseEnter={() => {
                            if (this.props.parcela.length !== 0) this.setState({hover: 'riego_neto'})
                        }}
                        onMouseLeave={() => {
                            if (this.props.parcela.length !== 0) this.setState({hover: ''})
                        }}
                        onClick={() => {
                            if (this.props.parcela.length !== 0) this.handleClickRiegoNeto()
                        }}
                    >
                        <Opacity
                            style={{
                                height: 35,
                                width: '20%',
                                color: this.props.parcela.length === 0? '#999' : '#000'
                            }}
                        />
                        <Typography
                            style={{
                                width: '80%',
                                fontSize: 18,
                                color: this.props.parcela.length === 0? '#999' : '#000',
                                fontFamily: "Poppins",
                            }}
                        >
                            {this.state.text["3"]}
                        </Typography>

                    </div>
                    :
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            marginTop: 20,
                            width: '100%',
                            height: 80,
                            alignItems: "center",
                            justifyContent: "center"
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                width: '100%',
                                height: 60,
                                justifyContent: "center"
                            }}
                        >
                            <Button
                                disabled={this.props.parcela.length === 0}
                                style={{
                                    width: 60,
                                    height: 60,
                                    borderRadius: 20,
                                    borderStyle: "solid",
                                    borderWidth: this.props.section === "riego_neto"? 1 : 0
                                }}
                                onClick={() => this.handleClickRiegoNeto()}
                            >
                                <Opacity
                                    style={{
                                        height: 35,
                                        width: 35
                                    }}
                                />
                            </Button>
                        </div>
                    </div>
                }






                {this.props.menu?
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            width: '100%',
                            height: 80,
                            justifyContent: "space-between",
                            alignItems: "center",
                            borderRadius: 10,
                            backgroundColor: this.state.hover === 'visualizador'? '#eee' : '#fff',
                            cursor: this.props.parcela.length === 0? "auto" : "pointer"
                        }}
                        onMouseEnter={() => {
                            if (this.props.parcela.length !== 0)this.setState({hover: 'visualizador'})
                        }}
                        onMouseLeave={() => {
                            if (this.props.parcela.length !== 0)this.setState({hover: ''})
                        }}
                        onClick={() => {
                            if (this.props.parcela.length !== 0)this.handleClickVisualizador()
                        }}
                    >
                        <Layers
                            style={{
                                height: 35,
                                width: '20%',
                                color: this.props.parcela.length === 0? '#999' : '#000'
                            }}
                        />
                        <Typography
                            style={{
                                width: '80%',
                                fontSize: 18,
                                color: this.props.parcela.length === 0? '#999' : '#000',
                                fontFamily: "Poppins",
                            }}
                        >
                            {this.state.text["4"]}
                        </Typography>

                    </div>
                    :
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            marginTop: 20,
                            width: '100%',
                            height: 80,
                            alignItems: "center",
                            justifyContent: "center"
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                width: '100%',
                                height: 60,
                                justifyContent: "center"
                            }}
                        >
                            <Button
                                disabled={this.props.parcela.length === 0}
                                style={{
                                    width: 60,
                                    height: 60,
                                    borderRadius: 20,
                                    // borderWidth: this.state.clickedParcelas? 1 : 0,
                                    borderStyle: "solid"
                                }}
                                onClick={() => this.handleClickVisualizador()}
                            >
                                <Layers
                                    style={{
                                        height: 35,
                                        width: 35
                                    }}
                                />
                            </Button>
                        </div>
                    </div>
                }



                {userService.getUser() !== 'demo'?
                    this.props.menu?
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                width: '100%',
                                height: 80,
                                justifyContent: "space-between",
                                alignItems: "center",
                                borderRadius: 10,
                                backgroundColor: '#fff',
                            }}

                        >
                            <Settings
                                style={{
                                    color: "#999",
                                    height: 35,
                                    width: '20%'
                                }}
                            />
                            <Typography
                                style={{
                                    width: '80%',
                                    fontSize: 18,
                                    fontFamily: "Poppins",
                                    color: "#999"
                                }}
                            >
                                {this.state.text["6"]}
                            </Typography>

                        </div>
                        :
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                marginTop: 20,
                                width: '100%',
                                height: 80,
                                alignItems: "center",
                                justifyContent: "center"
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    width: '100%',
                                    height: 60,
                                    justifyContent: "center"
                                }}
                            >
                                <Button
                                    style={{
                                        width: 60,
                                        height: 60,
                                        borderRadius: 20,
                                        borderStyle: "solid",
                                        borderWidth: this.props.section === "configuracion"? 1 : 0
                                    }}
                                    disabled={true}
                                >
                                    <Settings
                                        style={{
                                            height: 35,
                                            width: 35
                                        }}
                                    />
                                </Button>
                            </div>
                        </div>
                    :
                    null
                }


            </AppBar>
        )
    }

}


const mapStateToProps = (state: IStore) => ({
    section: state.navegacion.section,
    parcelas: state.principal.parcelas,
    center: state.principal.center,
    zoom: state.principal.zoom,
    level: state.navegacion.level,
    usuarios: state.principal.usuarios,
    usuario: state.principal.usuario,
    menu: state.navegacion.menu,
    LatLon: state.navegacion.elTiempoLatLon,
    parcela: state.navegacion.parcela,
    idioma: state.config.idioma
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    selectSection: (section: ISections) => dispatch({type: "select-section", section}),
    setNombre: (nombre: string) => dispatch({type: "set-crear-parcela-nombre", nombre}),
    setPropietario: (propietario: string) => dispatch({type: "set-crear-parcela-propietario", propietario}),
    setPolygon: (polygon: LatLngTuple[]) => dispatch({type: "set-crear-parcela-polygon", polygon}),
    setSectores: (sectores: Record<string, LatLngTuple[]>) => dispatch({type: "set-crear-parcela-sectores", sectores}),
    setZoom: (zoom: number) => dispatch({type: "set-principal-zoom", zoom}),
    setCenter: (center: LatLngTuple) => dispatch({type: "set-principal-center", center}),
    setPrincipalUsuario: (usuario: string) => dispatch({type: "set-principal-usuario", usuario}),
    setMenu: (menu: boolean) => dispatch({type: "set-menu", menu}),
    setElTiempoLatLon: (elTiempoLatLon: IPointCoords) => dispatch({type: "set-eltiempo_latlon", elTiempoLatLon}),
    setParcela: (parcela: string) => dispatch({type: "set-parcela", parcela}),
    setVisualizadorParcela: (parcela: IParcela) => dispatch({type: "set-visualizador-parcela", parcela}),
    setVisualizadorSectores: (sectores: Record<string, LatLngTuple[]>) => dispatch({type: "set-visualizador-sectores", sectores}),
    setParcelas: (parcelas: IParcela[]) => dispatch({type: "set-principal-parcelas", parcelas}),
    setRiego: (riego: Record<string, Record<string, number>>) => dispatch({type: "set-riego-riego", riego}),
    setPronostico: (pronostico: Record<string, Record<string, number>>) => dispatch({type: "set-riego-pronostico", pronostico}),
    notify: (notification: INotificacion) => dispatch({type: 'notify', notification}),
    setRiegoParcela: (parcela: IParcela) => dispatch({type: "set-riego-parcela", parcela}),
    setRiegoSectores: (sectores: Record<string, LatLngTuple[]>) => dispatch({type: "set-riego-sectores", sectores}),
    setSubirDatosParcela: (parcela: IParcela) => dispatch({type: "set-subir-datos-parcela", parcela}),
    Cargando: (cargando: boolean) => dispatch({type: "cargando", cargando})
});

export default connect(mapStateToProps, mapDispatchToProps)(NavBar);
